import { LIVE_PREVIEW_MOCKED_ID } from '../constants/common';

const getSortBlockVariationId = ({ isStrictlyClean }, sortBlockVariationId) => {
  if (sortBlockVariationId) return sortBlockVariationId;

  return isStrictlyClean ? null : LIVE_PREVIEW_MOCKED_ID;
};

export default getSortBlockVariationId;
